import React, { PureComponent, PropTypes } from 'react';
import classnames from 'classnames';
import { dragTarget } from '../decorators';

class Line extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.string,
        onDoubleClick: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
        populated: PropTypes.bool.isRequired
    }
    static defaultTypes = {
        className: '',
        placeholder: '?'
    }

    render() {
        const { className, label, onDoubleClick, placeholder, populated } = this.props;

        const classes = classnames({
            [className]: true,
            populated
        });

        return (<div className={ classes } onDoubleClick={ onDoubleClick }>{ label || placeholder }</div>);
    }
}

export default dragTarget(Line, 'line');


// WEBPACK FOOTER //
// ./src/components/importer/line.js